import styled from 'styled-components';
import { colors } from "../../../utils/colors";

export const SettingsButton = styled.div`
    overflow: hidden;
    position: relative;
    width: 150px;
    height: 150px;
    gap: 10px;
    border-radius: 30px;
    margin-bottom: 15px;
    opacity: 0;
    transform: scale(0);
    animation: buttonsAnimation 1000ms ease-in forwards;
    transition: 100ms;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: ${colors.BLUE};
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);

    background-image: linear-gradient(
                60deg,
                rgb(190, 190, 190),
                rgb(240, 240, 240),
                rgb(190, 190, 190)
              );
    
    @media (min-width: 1200px) {
        &:hover{
            cursor: pointer;
            box-shadow: 0 8px 8px -4px rgba(0,0,0,.3), 
                        0 8px 8px 0 rgba(0,0,0,.2),
                        0 2px 16px 0 rgba(0,0,0,.15);
        }
    }

    @keyframes buttonsAnimation {
        0% {
          opacity: 0;
          transform: scale(0.98);
        }
        100% {
          opacity: 100;
          transform: scale(1);
        }
    }
`;

export const SettingsButtonWrapper = styled.div`
    margin-top: 50px;
    columns: 2;

    @media (max-width: 800px) {
        columns: 2;
    }
`;

export const IconImage = styled.img`
    width: 70px;
`;

export const SettingsSpan = styled.span`
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word; 
`;